import { StoryblokComponent } from '@storyblok/react';
import { useMemo } from 'react';

import { createPortal } from 'react-dom';

import { Modal } from '../../../components/Modal/Modal';
import { patchedStoryblokEditable } from '../../../utils/patchedStoryblokEditable';
import { useFormBuilderContext } from '../hooks/useFormBuilderContext';
import { FormBuilderModalWrapper } from './FormBuilderModal.styles';
import { FormBuilderModalProps } from './FormBuilderModal.types';

export const FormBuilderModal = (props: FormBuilderModalProps) => {
  const { blok } = props;
  const {
    showCondition,
    key,
    value,
    body,
    maxWidth,
    dynamicHeight,
    borderRadius,
    fullWidthContent,
  } = blok;

  const { keyValues, setKeyValue } = useFormBuilderContext();

  const isOpen = useMemo(() => {
    if (showCondition === 'keyHasAnyValue') {
      return Boolean(keyValues[key]);
    }

    if (showCondition === 'keyHasSpecificValue') {
      return keyValues[key] === value;
    }
  }, [showCondition, key, value, keyValues]);

  const toggleModal = () => setKeyValue(key, '');

  if (typeof document === 'undefined') {
    return null;
  }

  return createPortal(
    <FormBuilderModalWrapper
      {...patchedStoryblokEditable(blok)}
      maxWidth={maxWidth}
      dynamicHeight={dynamicHeight}
      borderRadius={borderRadius}
      fullWidthContent={fullWidthContent}
    >
      <Modal isOpen={isOpen} toggleModal={toggleModal}>
        {body.map((blokData) => (
          <StoryblokComponent blok={blokData} key={blokData._uid} />
        ))}
      </Modal>
    </FormBuilderModalWrapper>,
    document.body
  );
};
